<template>
	<ul class="breadcrumb" :class="{arrow:arrow}">
		<slot></slot>
		<li v-if="!!data" v-for="(nav,index) in data" :class="[{active:nav.active}]" @click="changeNav(nav.name)">
			<a v-if="!nav.active">{{nav.name}}</a>
			<span v-else>{{nav.name}}</span>
		</li>
	</ul>
</template>
<script>
	import lib from "../../assets/js/lib.js"
	export default {
		name: 'bsf-breadcrumb',
		components: {},
		props: {
			btype: String,
			data: Array,
			arrow: Boolean
		},
		data() {
			return {
			}
		},
		methods: {
			changeNav(i) {
				this.$router.push({ name: i })
			}
		},
		mounted: function() {
			this.$nextTick(function() {

			})
		},
		computed: {
			seType() {
				return this.btype ? "arrow" : ""
			}
		}

	}
</script>
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.breadcrumb {
		.unbg;
		.unbdr;
		.pdl(0);
		li {
			a {
				color: @cc1;
				text-decoration: none;
				cursor: pointer;
				&:hover {
					color: @ces;
				}
			}
			&.active {
				a {
					color: @cc;
				}
			}
		}
		&.arrow {
			li+li:before {
				content: "〉";
			}
		}
	}
</style>


// WEBPACK FOOTER //
// breadcrumbs.vue?07372888